module.exports = __webpack_public_path__ + "img/天坛.1e273ba3.jpg";